export default [
  {
    path: '/refuseRegisterPage',
    name: 'RefuseRegisterPage',
    component: () => import('@/views/login/login.vue'),
    meta: { pageName: 'RefuseRegisterPage-refused' }
  }
]
